
import Vue from "vue";
import { AuthService } from "@/services/auth-service";
import { ToolbarService } from "@/services/toolbar-service";
import AppToolbarButton from "@/components/common/ToolbarButton.vue";
import AppNavItem from "@/components/common/DefaultRouteNavItem.vue";
import { UserInfo } from "@/models/dossier/user-info";

export default Vue.extend({
	data() {
		return {
			AuthService,
			ToolbarService
		};
	},
	computed: {
		drawer: {
			get(): boolean | number {
				return this.ToolbarService.drawer;
			},
			set(value: boolean | number) {
				this.ToolbarService.drawer = value;
			}
		},
		wfUser():UserInfo {
			return AuthService.wfUser;
		},
		profileImgUrl():string {
			return AuthService.wfUser.getProfileImgUrl();
		},
		options():any[] {
			return [
				{value: "logout", text: this.$ct("logout").toString(), icon: "sign-out-alt"}
			];
		}
	},
	watch: {
		"$wf.isSmDown"() {
			this.drawer = !this.$wf.isSmDown;
		}
	},
	methods: {
		selectClicked(e:string) {
			if (typeof((this as any)[e]) == "function") {
				(this as any)[e]();
			}
		},
		logout() {
			AuthService.logout();
		},
		toggleDrawer() {
			this.ToolbarService.drawer = !this.ToolbarService.drawer;
		}
	},
	mounted() {
		let splashEl = document.getElementById("splash");
		if (splashEl) splashEl.remove();
		this.drawer = !this.$wf.isSmDown;
	},
	components: {
		AppToolbarButton,
		AppNavItem
	},
	i18nEx: {
		componentPrefix: "views.AccountantShell"
	}
});
